var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2119_75516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4663 26.0754L37.3331 19.1777C38.5004 18.1542 40 17.5898 41.5525 17.5898H81.5992C85.1338 17.5898 87.9992 20.4552 87.9992 23.9898V97.5898C87.9992 101.124 85.1338 103.99 81.5992 103.99H25.5992C22.0646 103.99 19.1992 101.124 19.1992 97.5898V39.458C19.1992 37.8198 19.8274 36.244 20.9544 35.0551L29.4663 26.0754Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0886 23.7762L29.4663 26.0754L28.0477 27.572L29.2089 28.6728L30.5767 27.2297L33.1434 24.9792L32.0886 23.7762ZM26.629 29.0687L27.7902 30.1694L24.9529 33.1626L23.7917 32.0619L26.629 29.0687ZM22.373 33.5585L23.5342 34.6592L22.1156 36.1559C21.8345 36.4524 21.5949 36.7808 21.4002 37.1325L20.0005 36.3573C20.2601 35.8884 20.5797 35.4504 20.9544 35.0551L22.373 33.5585ZM19.1992 95.1677H20.7992V97.5898C20.7992 98.4669 21.033 99.2846 21.4406 99.9891L20.0557 100.79C19.511 99.8489 19.1992 98.7558 19.1992 97.5898V95.1677ZM79.2659 103.99V102.39H81.5992C82.4763 102.39 83.294 102.156 83.9984 101.748L84.7997 103.133C83.8583 103.678 82.7651 103.99 81.5992 103.99H79.2659ZM87.9992 26.4432H86.3992V23.9898C86.3992 23.1127 86.1654 22.2951 85.7578 21.5906L87.1427 20.7893C87.6874 21.7308 87.9992 22.8239 87.9992 23.9898V26.4432ZM43.7773 17.5898V19.1898H41.5525C40.3881 19.1898 39.2634 19.6131 38.3879 20.3807L35.7657 22.68L34.7108 21.4769L37.3331 19.1777C38.5004 18.1542 40 17.5898 41.5525 17.5898H43.7773ZM46.0021 17.5898V19.1898H50.4518V17.5898H46.0021ZM52.6766 17.5898V19.1898H57.1262V17.5898H52.6766ZM59.351 17.5898V19.1898H63.8007V17.5898H59.351ZM66.0255 17.5898V19.1898H70.4751V17.5898H66.0255ZM72.6999 17.5898V19.1898H77.1496V17.5898H72.6999ZM79.3744 17.5898V19.1898H81.5992C82.4763 19.1898 83.294 19.4236 83.9984 19.8312L84.7997 18.4463C83.8583 17.9016 82.7651 17.5898 81.5992 17.5898H79.3744ZM87.9992 28.8965H86.3992V33.8032H87.9992V28.8965ZM87.9992 36.2565H86.3992V41.1632H87.9992V36.2565ZM87.9992 43.6165H86.3992V48.5232H87.9992V43.6165ZM87.9992 50.9765H86.3992V55.8832H87.9992V50.9765ZM87.9992 58.3365H86.3992V63.2432H87.9992V58.3365ZM87.9992 65.6965H86.3992V70.6032H87.9992V65.6965ZM87.9992 73.0565H86.3992V77.9632H87.9992V73.0565ZM87.9992 80.4165H86.3992V85.3232H87.9992V80.4165ZM87.9992 87.7765H86.3992V92.6832H87.9992V87.7765ZM87.9992 95.1365H86.3992V97.5898C86.3992 98.4669 86.1654 99.2846 85.7578 99.9891L87.1427 100.79C87.6874 99.8489 87.9992 98.7558 87.9992 97.5898V95.1365ZM76.9326 103.99V102.39H72.2659V103.99H76.9326ZM69.9326 103.99V102.39H65.2659V103.99H69.9326ZM62.9326 103.99V102.39H58.2659V103.99H62.9326ZM55.9326 103.99V102.39H51.2659V103.99H55.9326ZM48.9326 103.99V102.39H44.2659V103.99H48.9326ZM41.9326 103.99V102.39H37.2659V103.99H41.9326ZM34.9326 103.99V102.39H30.2659V103.99H34.9326ZM27.9326 103.99V102.39H25.5992C24.7221 102.39 23.9045 102.156 23.2 101.748L22.3987 103.133C23.3402 103.678 24.4333 103.99 25.5992 103.99H27.9326ZM19.1992 92.7455H20.7992V87.9012H19.1992V92.7455ZM19.1992 85.479H20.7992V80.6347H19.1992V85.479ZM19.1992 78.2126H20.7992V73.3682H19.1992V78.2126ZM19.1992 70.9461H20.7992V66.1018H19.1992V70.9461ZM19.1992 63.6796H20.7992V58.8353H19.1992V63.6796ZM19.1992 56.4131H20.7992V51.5688H19.1992V56.4131ZM19.1992 49.1467H20.7992V44.3023H19.1992V49.1467ZM19.1992 41.8802H20.7992V39.458C20.7992 39.0495 20.8513 38.6462 20.9519 38.2571L19.4028 37.8567C19.2687 38.3756 19.1992 38.9134 19.1992 39.458V41.8802Z",
    fill: "#999FAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.218 37.3747V35.7747H21.283L20.7444 35.3475L20.228 36.1367C19.8799 36.6688 20.2616 37.3747 20.8974 37.3747H22.218ZM41.018 22.4414H39.418V27.5081H41.018V22.4414ZM41.018 30.0414H39.418V32.5747C39.418 33.1604 39.2621 33.7047 38.9907 34.1738L40.3756 34.9751C40.7841 34.269 41.018 33.4492 41.018 32.5747V30.0414ZM38.6184 36.7324L37.8171 35.3475C37.348 35.6189 36.8036 35.7747 36.218 35.7747H33.418V37.3747H36.218C37.0924 37.3747 37.9123 37.1409 38.6184 36.7324ZM30.618 37.3747V35.7747H25.018V37.3747H30.618Z",
    fill: "#999FAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2491 11.9403C15.7178 11.4717 16.4776 11.4717 16.9462 11.9403L23.1687 18.1629C23.6374 18.6315 23.6374 19.3913 23.1687 19.8599C22.7001 20.3285 21.9403 20.3285 21.4717 19.8599L15.2491 13.6374C14.7805 13.1688 14.7805 12.409 15.2491 11.9403Z",
    fill: "#E2E5EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.905 35.3956C105.374 35.8642 105.374 36.624 104.905 37.0927L103.774 38.224C103.305 38.6927 102.546 38.6927 102.077 38.224C101.608 37.7554 101.608 36.9956 102.077 36.527L103.208 35.3956C103.677 34.927 104.437 34.927 104.905 35.3956Z",
    fill: "#E2E5EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.429 30.8644C109.897 31.333 109.897 32.0928 109.429 32.5614L108.297 33.6928C107.829 34.1614 107.069 34.1614 106.6 33.6928C106.132 33.2242 106.132 32.4644 106.6 31.9957L107.732 30.8644C108.2 30.3957 108.96 30.3957 109.429 30.8644Z",
    fill: "#E2E5EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.601 35.3915C107.069 34.9229 107.829 34.9229 108.298 35.3915L109.429 36.5229C109.898 36.9915 109.898 37.7513 109.429 38.2199C108.96 38.6886 108.201 38.6886 107.732 38.2199L106.601 37.0886C106.132 36.6199 106.132 35.8601 106.601 35.3915Z",
    fill: "#E2E5EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.077 30.8681C102.546 30.3994 103.306 30.3994 103.774 30.8681L104.906 31.9994C105.374 32.4681 105.374 33.2279 104.906 33.6965C104.437 34.1651 103.677 34.1651 103.209 33.6965L102.077 32.5651C101.609 32.0965 101.609 31.3367 102.077 30.8681Z",
    fill: "#E2E5EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3546 86.796C6.82323 87.2646 6.82323 88.0244 6.3546 88.4931L5.22323 89.6244C4.7546 90.0931 3.9948 90.0931 3.52617 89.6244C3.05754 89.1558 3.05754 88.396 3.52617 87.9274L4.65754 86.796C5.12617 86.3274 5.88597 86.3274 6.3546 86.796Z",
    fill: "#E2E5EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.878 82.2648C11.3467 82.7334 11.3467 83.4932 10.878 83.9618L9.74666 85.0932C9.27803 85.5618 8.51824 85.5618 8.04961 85.0932C7.58098 84.6246 7.58098 83.8648 8.04961 83.3961L9.18098 82.2648C9.64961 81.7961 10.4094 81.7961 10.878 82.2648Z",
    fill: "#E2E5EA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04991 86.7919C8.51854 86.3233 9.27834 86.3233 9.74697 86.7919L10.8783 87.9233C11.347 88.3919 11.347 89.1517 10.8783 89.6203C10.4097 90.0889 9.64991 90.0889 9.18128 89.6203L8.04991 88.4889C7.58128 88.0203 7.58128 87.2605 8.04991 86.7919Z",
    fill: "#E2E5EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52647 82.2665C3.9951 81.7979 4.7549 81.7979 5.22353 82.2665L6.3549 83.3979C6.82353 83.8665 6.82353 84.6263 6.3549 85.0949C5.88627 85.5636 5.12647 85.5636 4.65784 85.0949L3.52647 83.9636C3.05784 83.4949 3.05784 82.7351 3.52647 82.2665Z",
    fill: "#E2E5EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1606 90.79C97.2894 90.79 108.743 79.3363 108.743 65.2075C108.743 51.0787 97.2894 39.625 83.1606 39.625C69.0318 39.625 57.5781 51.0787 57.5781 65.2075C57.5781 79.3363 69.0318 90.79 83.1606 90.79Z",
    fill: "#E7FFF6",
    stroke: "#00C795",
    strokeWidth: 4.55795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.137 97.1859L101.227 83.2754",
    stroke: "#00C795",
    strokeWidth: 4.55795,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1992 72.7878C67.1992 72.7878 70.7548 70.1211 77.8659 70.1211C84.977 70.1211 88.5326 72.7878 88.5326 72.7878",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1992 60.7887C67.1992 60.7887 68.5326 62.3887 71.1992 62.3887C73.8659 62.3887 75.1992 60.7887 75.1992 60.7887",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60.7887C80 60.7887 81.3333 62.3887 84 62.3887C86.6667 62.3887 88 60.7887 88 60.7887",
    stroke: "black",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0125 9.42091C29.3562 9.32868 28.7494 9.78594 28.6572 10.4422L27.7665 16.7799C27.6743 17.4362 28.1315 18.043 28.7878 18.1353C29.4441 18.2275 30.0509 17.7703 30.1431 17.114L31.0339 10.7762C31.1261 10.12 30.6688 9.51315 30.0125 9.42091Z",
    fill: "#E2E5EA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1992 25.1887C11.1992 25.8514 11.7365 26.3887 12.3992 26.3887H18.7992C19.462 26.3887 19.9992 25.8514 19.9992 25.1887C19.9992 24.5259 19.462 23.9887 18.7992 23.9887H12.3992C11.7365 23.9887 11.1992 24.5259 11.1992 25.1887Z",
    fill: "#E2E5EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2119_75516",
    x: 16.7992,
    y: 16.7898,
    width: 73.6008,
    height: 91.2004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2119_75516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2119_75516",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReports);
export default __webpack_public_path__ + "static/media/no_reports.cae023bd9efe34cc3bccfc930977d1cf.svg";
export { ForwardRef as ReactComponent };